import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux'
import { Helmet } from 'react-helmet';
import { fab } from '@fortawesome/free-brands-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTshirt,
         faCoins,
         faWrench,
         faHandRock,
         faExclamation,
         faCheckCircle,
         faCertificate,
         faVial,
         faEye } from '@fortawesome/free-solid-svg-icons'

import createHistory from 'history/createHashHistory'

import MainMenu from './common/menu/MainMenu';
import MainContainer from './main/MainContainer';
import ItemContainer from './items/ItemContainer';
import AboutComponent from './about/AboutComponent';
import ItemSetContainer from './itemsets/ItemSetContainer';
import AppearanceContainer from './appearances/AppearanceContainer';

// import logo from './logo.svg';
import './App.css';

import store from './store/configureStore';

// Create a history of your choosing (we're using a browser history in this case)
export const history = createHistory();

// Initialize the font awesome library
library.add(fab, faTshirt, faWrench, faCoins, faHandRock, faExclamation, faCheckCircle, faCertificate, faVial, faEye);

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div className="container Site">
            <Helmet>
              <title>TelaraDb</title>
            </Helmet>
            <MainMenu />
            <div className="Site-content">
              <Switch>
                <Route
                  path="/items"
                  component={ItemContainer}
                />
                <Route
                  path="/itemsets/:id"
                  component={ItemSetContainer}
                />
                <Route
                  path='/appearances'
                  component={AppearanceContainer}
                />
                <Route
                  path="/about"
                  component={AboutComponent}
                />
                <Route
                  path="/"
                  component={MainContainer}
                />
              </Switch>
            </div>
          </div>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js